import generateRouterPreviewUrl from '../utils/router/generateAnalyticsUrl';

const openSurveyAnalytics = surveyId =>
  window.open(`${generateRouterPreviewUrl(surveyId)}`, '_blank');

export default openSurveyAnalytics;
